package ui.translation

import androidx.compose.runtime.*
import common.frontend.api.Io
import common.frontend.api.canTranslationAdd
import common.frontend.api.canTranslationEdit
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.FilePicker
import tools.printStackTraceInDebug
import ui.snackBarStateGlobal

@VM
class TranslationListingVM : NavigationViewModel() {

    private lateinit var scopeUi: TranslationListingScope

    var canAdd by mutableStateOf(false)
        private set

    var canEdit by mutableStateOf(false)
        private set

    var state by mutableDataState<TranslationListingScope.Wrapper>()
        private set


    sealed interface Action {
        data object New : Action
        data object Save : Action
        companion object {

            @Composable
            fun rememberAction(vm: TranslationListingVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            New -> vm.uploadNewTranslations()
                            Save -> vm.editTranslations()
                        }
                    }
                }
            }
        }
    }


    fun init(scopeUi: TranslationListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        canAdd = scopeUi.login.canTranslationAdd()
        canEdit = scopeUi.login.canTranslationEdit()


        scope.launch {
            runCatching {
                loadNewState()
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }

        }
    }

    private fun uploadNewTranslations() {
        scope.launch {
            FilePicker.single("application/json")
                ?.also {
                    runCatching {
                        Repository.api.translation.add(it.bytes.decodeToString())
                    }.onSuccess {
                        snackBarStateGlobal.showSnackbar(
                            it,
                            withDismissAction = true
                        )
                        loadNewState()
                    }.onFailure {
                        it.printStackTraceInDebug()
                        state = DataState.Error(it.message!!, throwable = it)
                    }
                } ?: run { println("no file pick") }
        }
    }

    private suspend fun loadNewState() {
        state = DataState.Result(
            TranslationListingScope.Wrapper(
                Repository.api.translation.listing()
            )
        )
    }


    private fun editTranslations() {
        scope.launch {
            runCatching {
                state.entry?.state
                    ?.map { it.data }
                    ?.toMutableList()
                    ?.let { Io.ListingTranslation(it) }
                    ?.also {
                        val result = Repository.api.translation.edit(it)
                        state = DataState.Result(
                            TranslationListingScope.Wrapper(result)
                        )
                    }
            }.onFailure {
                it.printStackTraceInDebug()
                snackBarStateGlobal.showSnackbar(
                    it.message!!,
                    withDismissAction = true
                )
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
